export const Coupon = {
  check: {
    url: "/coupon/check",
    method: ["POST"],
    required: [
    ]
  }
};
